// src/components/DashboardCustomer/DashboardCustomer.js
import BalanceCard from '@/components/Dashboard/BalanceCard';
import LoadDetailsCard from '@/components/Dashboard/LoadDetailsCard';
import ProductsInTransit from '@/components/Dashboard/ProductsInTransit';
import SalesChart from '@/components/Dashboard/SalesChart';
import SimulationComponent from '@/components/Dashboard/SimulationComponent';
import Layout from '@/content/Layouts';
import { Box, Typography, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import data from '@/components/Dashboard/ProductsInTransit/data';

function DashboardCustomer() {
  const [inTransitData, setInTransitData] = useState([]);
  const balance = 5000;
  const loadDetails = { kg: 2000, m3: 150, kap: 10 };

  const salesData = [
    { month: 'Ocak', satış: 4000, kar: 2400 },
    { month: 'Şubat', satış: 3000, kar: 1398 },
    { month: 'Mart', satış: 2000, kar: 9800 },
    { month: 'Nisan', satış: 2780, kar: 3908 },
    { month: 'Mayıs', satış: 1890, kar: 4800 },
    { month: 'Haziran', satış: 2390, kar: 3800 },
    { month: 'Temmuz', satış: 3490, kar: 4300 }
  ];

  useEffect(() => {
    const fetchData = async () => {
      setInTransitData(data);
    };

    fetchData();
  }, []);

  return (
    <Layout title="Müşteri Paneli">
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Müşteri Paneli
        </Typography>

        <Grid container spacing={3}>
          {/* Kullanıcı Bakiyesi */}
          <Grid item xs={12} md={6}>
            <BalanceCard balance={balance} />
          </Grid>

          {/* KG, M3, Kap Sayısı */}
          <Grid item xs={12} md={6}>
            <LoadDetailsCard
              kg={loadDetails.kg}
              m3={loadDetails.m3}
              kap={loadDetails.kap}
            />
          </Grid>

          {/* Satış Grafiği */}
          <Grid item xs={12}>
            <SalesChart data={salesData} />
          </Grid>

          {/* Yoldaki Ürünler */}
          <Grid item xs={12}>
            <ProductsInTransit data={inTransitData} />
          </Grid>

          {/* Simülasyon */}
          <Grid item xs={12} md={6}>
            <SimulationComponent />
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
}

export default DashboardCustomer;
